import { ActionListItem, Link, Text } from "@certn/cascadia-react";

interface Props {
  item: string;
  description: string;
  linkText: string;
  link: string;
  testID?: string;
}

export function HelpAndPrivacyLinkItem(props: Props) {
  const {
    item,
    description,
    linkText,
    link,
    testID = "help-and-privacy-link-item",
  } = props;

  return (
    <>
      <ActionListItem
        displayAccessibility
        testID={testID}
        title={item}
        trailing={
          <Link
            testID="help-and-privacy-link-item-link"
            linkStyle="monochrome"
            textStyle="global/body-secondary"
            href={link}
          >
            <Text color="text-weak">{linkText}</Text>
          </Link>
        }
      >
        <Text style="form/body-secondary" color="text-weak">
          {description}
        </Text>
      </ActionListItem>
    </>
  );
}
